import React, { useEffect, useState } from "react";
import moment from "moment";
import UserComponent from "../../components/user/UserComponent";
import Loading from "../../../components/isLoading";
import { fetchUserData } from "../../../redux/users/index";
import { Edit, Publish, DeleteForever } from "@material-ui/icons";
import apiService from "../../../services/allInOneService";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import DeleteConfirm from "../../../components/Dialogs/DeleteConfirm";
import { toast } from "react-toastify";

const BlogContainer = (props) => {
	const { id } = props;
	const [state, setState] = useState({
		openDeleteMessage: false,
	});
	const userData = useSelector((state) => state.user);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	useEffect(() => {
		if (id && id !== userData.data.id) {
			dispatch(fetchUserData(id));
		}
	}, []);

	const handleOnEdit = () => navigate("edit");

	const handleOpenCloseDeleteModel = (condition) =>
		setState((prevState) => ({ ...prevState, openDeleteMessage: condition }));

	const crumps = [
		{
			title: "Users",
			path: "/users",
		},
	];
	const actions = [
		{
			onClick: handleOnEdit,
			text: "Edit User",
			icon: <Edit fontSize="small" />,
		},
		{
			onClick: () => handleOpenCloseDeleteModel(true),
			text: "Delete User",
			icon: <DeleteForever fontSize="small" />,
		},
	];

	return userData.loading ? (
		<Loading />
	) : (
		<div>
			<UserComponent
				user={userData.data || {}}
				crumps={crumps}
				actions={actions}
			/>
		</div>
	);
};

export default BlogContainer;
